import { toDisplayString as _toDisplayString, createVNode as _createVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-9a33fdaa")

_pushScopeId("data-v-9a33fdaa")
const _hoisted_1 = { class: "name" }
const _hoisted_2 = { class: "text" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_SpeakerButton = _resolveComponent("SpeakerButton")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("span", _hoisted_2, _toDisplayString(_ctx.name), 1),
    (!_ctx.isStartSettings)
      ? (_openBlock(), _createBlock(_component_SpeakerButton, {
          key: 0,
          isAdmin: false,
          endpointId: _ctx.endpointId,
          hasVideo: _ctx.hasVideo
        }, null, 8, ["endpointId", "hasVideo"]))
      : _createCommentVNode("", true)
  ]))
})